module.exports = __webpack_public_path__ + "static/media/space-food_008.4035f817.jpg";